import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const mutationFn = ({ addressIds, stepId }) => {
  return request.put(
    'FlatsGrid/mass_change_step_address_life_cycle',
    { addressIds, stepId },
    undefined,
    'Error',
    undefined,
    undefined,
    undefined,
    true
  );
};

export const useMassChangeStep = (options) => {
  return useMutation(mutationFn, options);
};
